import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    const isLoading = ref(false)
    
    nuxtApp.provide('pageLoading', isLoading)
    
    nuxtApp.hook('page:start', () => {
      // Immediate loading feedback
      isLoading.value = true
    })
    
    nuxtApp.hook('page:finish', () => {
      // Remove artificial delay - show page immediately when ready
      isLoading.value = false
    })
    
    const router = useRouter()
    
    router.beforeEach((to, from) => {
      // Immediate loading feedback for route changes
      if (to.path !== from.path) {
        isLoading.value = true
      }
      return true
    })
    
    router.afterEach((to, from) => {
      // Only set to false if it's the same path (query changes)
      if (to.path === from.path) {
        isLoading.value = false
      }
    })
    
    // Handle navigation errors
    router.onError(() => {
      isLoading.value = false
    })
  }
}) 